module.exports = new __parcel__URL__("search-no-results-darkmode.c66ae5fb.svg").toString();